// 生成 UUID 的方案, 参考小程序实现
function genUUID() {
  const len = 36; // 长度为36
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];
  let i;

  let r;
  uuid[8] = '-';
  uuid[13] = '-';
  uuid[18] = '-';
  uuid[23] = '-';
  uuid[14] = '4';
  for (i = 0; i < len; i++) {
    if (!uuid[i]) {
      r = 0 | Math.random() * 16;
      uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
    }
  }

  return uuid.join('');
}

export {
  genUUID,
};
